import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import {Field, reduxForm, isDirty} from 'redux-form'
import {ActionBarWrapper} from 'components/wrappers/pages'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import {
  onChangeOutletIds,
  onChangeKeyword,
  onClickCreateCategory
} from 'actions/ingredients/category'
import {askConfirmAction} from 'actions/confirm-action'
import styles from './ActionBar.css'

class ActionBar extends React.Component {
  render () {
    const {outlets} = this.props
    return (<ActionBarWrapper>
      <div className='col-sm-8' style={{paddingLeft: 0}}>
        <form className={`form-inline ${styles['action-bar']}`}>
          <div className='form-group mr-5px'>
            <Field
              name='outletIds'
              component={DropdownOutlet}
              outlets={outlets}
              onChangeOutletIds={this._onChangeOutletIds}
            />
          </div>
          <div className='form-group mr-5px'>
            <Field
              name='keyword'
              component={SearchBar}
              onChange={this._onChangeKeyword}
              placeholder='Search'
            />
          </div>
        </form>
      </div>
      <div className='col-sm-4' style={{paddingRight: 0}}>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onClickCreateCategory}>Create Ingredient Category</button>
        </span>
      </div>
    </ActionBarWrapper>)
  }

  _onChangeOutletIds = (outletIds) => {
    const {isDirtyForm} = this.props
    if (isDirtyForm) {
      this.props.dispatch(askConfirmAction(onChangeOutletIds(outletIds)))
    } else {
      this.props.dispatch(onChangeOutletIds(outletIds))
    }
  }

  _onChangeKeyword = (event, keyword) => {
    this.props.dispatch(onChangeKeyword(keyword))
  }

  _onClickCreateCategory = () => {
    const {isDirtyForm} = this.props
    if (isDirtyForm) {
      this.props.dispatch(askConfirmAction(onClickCreateCategory()))
    } else {
      this.props.dispatch(onClickCreateCategory())
    }
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  const {outlets} = state.ingredients.category
  return {
    outlets,
    isDirtyForm: isDirty('ingCategory')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/ActionBar/ActionBar.js